import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {WcvLog} from '../../graphql/logs.datatypes';
import {gqlLog} from './getLogs.api';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../graphql/common.datatypes';

interface LogsData {
    logs: void,
    groupLogs: {
        data: WcvLog[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_GROUP_LOGS_QUERY = gql`
    query getGroupLogs($count: Int!, $page: Int!, $where: WhereConditions, $orderBy: [OrderByClause!]){
        groupLogs(first: $count, page: $page, where: $where, orderBy: $orderBy){
            data {
                ${gqlLog}
            }
            ${gqlPaginatorInfo}
        }
    }
`;

export const getGroupLogs = (count: number, page: number, where?: any, orderBy?: any) => useQuery<LogsData>(
    GET_GROUP_LOGS_QUERY,
    {
        variables: {
            count,
            page,
            where,
            orderBy,
        }
    }
);


export default getGroupLogs;
